import type { CallFormFields } from "./pages/first-line/CallForm.interface";
import type { ChatFormFields } from "./pages/first-line/ChatForm.interface";

export const ISupportLines = {
  firstLine: "FIRST_LINE",
  secondLine: "SECOND_LINE",
} as const;

export type ISupportLines = (typeof ISupportLines)[keyof typeof ISupportLines];

export const ISecondLineRoutes = {
  reschedule: "RESCHEDULE_SCRIPT",
  remider: "REMINDER_SCRIP",
  success: "SUCCESS_SCRIPT",
  accessibilityInterval: "ACCESSIBILITY_INTERVAL_SCRIPT",
  newService: "NEW_SERVICE_SCRIPT",
  default: "DEFAULT",
} as const;

export type ISecondLineRoutes =
  (typeof ISecondLineRoutes)[keyof typeof ISecondLineRoutes];

export const IFirstLineRoutes = {
  chatForm: "CHAT_FORM",
  callForm: "CALL_FORM",
  default: "DEFAULT",
} as const;

export type IFirstLineRoutes =
  (typeof IFirstLineRoutes)[keyof typeof IFirstLineRoutes];

export interface IKitPostmessage {
  origin: string;
  data: {
    agent_data: IKitAgentData;
    active_task_data: IKitActiveTaskData;
  };
}

export interface IKitAgentData {
  group_id: number;
}

export interface IVariables {
  script: string;
  lead_id: string;
}

export interface IKitActiveTaskData {
  task_type: string;
  CUSTOMER: ICustomer;
  VARIABLES: IVariables;
}

export interface ICustomer {
  customer_phones: string[];
}

export interface ICommonFormFields {
  stage: string;
  phone: string;
  age: string;
  citizenship: IOption | null;
  city: IOption | null;
  lastName: string;
  firstName: string;
  middleName: string;
  dateOfBirth: string;
  education: IOption | null;
  contractType: IOption | null;
  role: IOption | null;
  contractDate: string;
  educationDateTime: string;
  educationCenter: IOption | null;
  inn: string;
  insuranceNumber: string;
  transportType: IOption | null;
  foreignCitizen: boolean;
  minor: boolean;
  office: boolean;
  preFilledFCForm: boolean;
  rejectionReason: IOption | null;
  reservationReason: IOption | null;
  company: IOption | null;
  region: IOption | null;
  hireType: IOption | null;
  sex: IOption | null;
}

export type CommonFormFields = keyof ICommonFormFields;

export const commonFieldsLabels = {
  stage: "Стадия",
  phone: "Телефон",
  age: "Возраст",
  citizenship: "Гражданство",
  city: "Город",
  lastName: "Фамилия",
  firstName: "Имя",
  middleName: "Отчество",
  dateOfBirth: "Дата рождения",
  education: "Образование",
  contractType: "Тип договора",
  role: "Роль",
  contractDate: "Дата заключения договора",
  educationDateTime: "Дата и время обучения",
  educationCenter: "ЦФЗ обучения",
  inn: "ИНН",
  insuranceNumber: "СНИЛС",
  transportType: "Тип транспорта",
  foreignCitizen: "Иностранный гражданин",
  minor: "Несовершеннолетний",
  office: "Офис",
  preFilledFCForm: "ИГ предзаполненная анкета",
  rejectionReason: "Причина отказа",
  reservationReason: "Причина резерва",
  company: "Компания",
  region: "Регион",
  hireType: "Тип найма",
  sex: "Пол",
} as const satisfies Record<CommonFormFields, string>;

export const callFieldsLabels = commonFieldsLabels satisfies Record<
  CallFormFields,
  string
>;

export const chatFieldsLabels = {
  ...commonFieldsLabels,
  ka: "КА",
} as const satisfies Record<ChatFormFields, string>;

export type FieldLabels =
  (typeof chatFieldsLabels)[keyof typeof chatFieldsLabels];

export interface ILeadData {
  stage: string;
  age: string;
  citizenship: IOption | null;
  city: IOption | null;
  ka: IOption | null;
  lastName: string;
  firstName: string;
  middleName: string;
  dateOfBirth: string;
  education: IOption | null;
  contractType: IOption | null;
  role: IOption | null;
  contractDate: string;
  educationDateTime: string;
  educationCenter: IOption | null;
  inn: string;
  insuranceNumber: string;
  transportType: IOption | null;
  foreignCitizen: boolean;
  minor: boolean;
  office: boolean;
  preFilledFCForm: boolean;
  rejectionReason: IOption | null;
  reservationReason: IOption | null;
  company: IOption | null;
  region: IOption | null;
  hireType: IOption | null;
  sex: IOption | null;
}

export interface IOption {
  id: number;
  value: string;
}

export const requiredFieldsStatuses = {
  loading: "loading",
  loaded: "loaded",
  failed: "failed",
} as const;

export const clientDataStatuses = {
  loading: "loading",
  found: "found",
  notFound: "notFound",
} as const;
